import React, { useEffect, useState } from "react";
import "./SubcategoriesRewardsScreen.css";
import Footer from "../../../../Layout/Footer/Footer";
import Header from "../../../../Layout/Header/Header";
import CustomLoader from "../../../../CustomComponents/CustomLoader/CustomLoader";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getProductCategoryDetailsAPI } from "../../../../../../Store/Action/productCategory";
import RewardProgressCircle from "../../../../CustomComponents/RewardProgressCircle"; // ✅ optional for subcategory progress
import Icons from "../../../../../../Config/Images";
import { toast } from "react-toastify";

const SubcategoriesRewardsScreen = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  // const [categories, setCategories] = useState([]);

  const rewardPointUnitId = useSelector(
    (state) => state.rewardPoint.rewardPointUnitId
  );

  const { target } = location.state || {};
  const categories = target?.subCategories || [];

  // useEffect(() => {
  //   setLoading(true);
  //   const params = {
  //     milestone_id: location?.state?.target?.id,
  //     reward_point_unit_id: rewardPointUnitId,
  //   };
  //   //
  //   dispatch(
  //     getProductCategoryDetailsAPI(params, (result) => {
  //       if (result?.status) {
  //         setCategories(result.data || []);
  //       }
  //       setLoading(false);
  //     })
  //   );
  // }, [dispatch, location?.state?.target?.id]);

  const handleClickCard = (data) => {
    // return
    const prodName = data.product_category_name.toLowerCase().replace(" ", "-");

    navigate(`/my-account/reward-points/${prodName}`, {
      state: {
        header_name: data.product_category_name,
        subCategoryId: data.product_category_id,
        // weight: target.weight,
        // unit: data.milestone_unit,
        mileStoneId: location?.state?.target?.mileStoneId,
        mileStoneFlag: location?.state?.target?.mileStoneFlag,
      },
    });
  };
  // const handleExploreClick = () => {
  //   if (location.state.subCategoryId) {
  //     navigate(`/productsList/${location.state.subCategoryId}`, {
  //       state: { subCategoryName: location.state.header_name },
  //     });
  //   } else {
  //     toast.error("Something went wrong!");
  //   }
  // };
  return (
    <>
      <Header />
      <div
        className="reward-points-main-div"
        style={{ backgroundColor: categories?.length === 0 ? "#ffffff" : "" }}
      >
        <div className="account-header">
          <p className="ac-header-para">{`${location?.state?.target?.name} ${location?.state?.target?.weight} ${location?.state?.target?.unit}`}</p>
        </div>

        <div className="divider" />

        {loading ? (
          <div className="loaderContainer">
            <CustomLoader />
          </div>
        ) : categories.length === 0 ? (
          // ✅ Empty State
          <div className="EmptyCartDiv">
            <div className="text-content">
              <h3>No Categories Found</h3>
              <p>
                Looks like you haven’t achieved any rewards in this milestone
                yet.
              </p>
            </div>
            <img src={Icons.emptyCartImage} alt="empty rewards" />
            <div className="button-shopping">
              <button onClick={() => navigate("/home")}>Explore now</button>
              {/* <button onClick={() => handleExploreClick()}>Explore now</button> */}
            </div>
          </div>
        ) : (
          <div className="categories-container">
            <div className="category-block">
              {/* Header */}
              {/* <p className="ac-header-para">
                {`${target.name} ${target.weight} ${target.unit}`}
              </p> */}

              {/* Progress Bar */}
              <div className="progress-bar-div">
                <p className="progress-text-para">Your Progress</p>
                <div className="progress-bar-ka-div">
                  <div
                    className="progress-fill"
                    style={{ width: `${target.progress}%` }}
                  />
                  <p className="progress-center-text">{target.progress}%</p>
                </div>
              </div>

              {/* Subcategory Cards */}
              <div className="subcategory-cards">
                {categories.map((sub) => (
                  <div
                    key={sub.product_category_id}
                    className="subcategory-card"
                    onClick={() => handleClickCard(sub)}
                  >
                    <RewardProgressCircle
                      progress={Number(sub.milestone_percentage) || 0}
                    />
                    <p className="product-name-paraaa">
                      {sub.product_category_name}
                    </p>
                    <p className="product-name-para-priceee">
                      {sub.reward_weight} {target.unit}
                    </p>
                    <p className="subcategory-progress-text">
                      {sub.milestone_percentage}% achieved
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
      <Footer />
    </>
  );
};

export default SubcategoriesRewardsScreen;
